module.exports = __webpack_public_path__ + "static/Juan Erazo Deacon-3af1c8b46c446b33c7e5fca6faec8df8.jpg";